// Libs
import * as React from 'react'
import { connect } from 'react-redux'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { withTheme } from '@material-ui/core/styles'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import IconButton from '@material-ui/core/IconButton'
import ArrowBack from '@material-ui/icons/ArrowBack'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
// Components
import ProgressBar from '../shared/ProgressBar'
import Routes from './Routes'
import Snackbar from '../shared/Snackbar'
// Store
import { authSuccess } from './duck/actions'
import { loadData } from './duck/actions'
// import Auth from '../lib/Auth'
// Assets
import logowhite from '../img/logo-white.png'


interface IAppProps extends RouteComponentProps<{}> {
  theme: any
  authenticated: boolean
  authSuccess: (profile: any) => void
  loadData: () => void
}

class App extends React.Component<IAppProps, {}> {
  public async componentDidMount() {
    // Load all the factoid, classes, and BL's
    this.props.loadData()
    // If not a landing page, do auth stuff
    // if (!this.props.location.pathname.includes('/view/')) {
    //   if (Auth.isAuthenticated()) {
    //     const res = await Auth.getUserInfo()
    //     const profile: any = { ...res }
    //     this.props.authSuccess(profile)
    //   } else {
    //     this.props.history.push('/login')
    //   }
    // }
  }

  public render() {
    const shouldShowProgressBar = this.props.location.pathname.includes(
      '/views/new'
    ) && !this.props.location.pathname.includes('/views/new/success') ? true : false
    
    const shouldShowBackBtn =  this.props.history.location.pathname !== '/login' &&
      this.props.history.location.pathname !== '/views' &&
      !this.props.history.location.pathname.includes('/view/')


    const shouldShowAppLogo = this.props.history.location.pathname !== '/login'

    const shouldShowExperienceManagerBtn = this.props.history.location.pathname !== '/login' && !this.props.history.location.pathname.includes('/view/')

    return (
      <Outer>
        <Header>
          <AppBar style={{ backgroundColor: '#E4002B' }}>
            <Toolbar>
              <ToolbarGrid>
                { shouldShowBackBtn ?   
                  (
                    <IconButton style={{color: '#fff',padding: '12px 80px 12px 0px', justifyContent: 'flex-start'}}>
                      <ArrowBack onClick={this.props.history.goBack} />
                    </IconButton>
                  ) 
                  : null
                }
                {shouldShowAppLogo ?  <img src={logowhite} alt="cushman and wakefield" style={{cursor: 'pointer' }} onClick={() => this.props.history.push('/views/new')} /> : null}
                { shouldShowExperienceManagerBtn ? (
                  <Button className='experience-manager-btn' >          
                  <Link style={{color: '#eee'}} to="/views">Experience manager</Link>
                  </Button>  
                  ) 
                  : null
                }
              </ToolbarGrid>
            </Toolbar>
          </AppBar>
          {shouldShowProgressBar && <ProgressBar />}
        </Header>
        <Routes />
        <Snackbar />
      </Outer>
    )
  }
}

export default withTheme()(
  withRouter(
    connect(
      (state: any) => ({ authenticated: state.profile.authenticated }),
      { authSuccess, loadData }
    )(App)
  )
)

const Outer = styled.div`
  display: grid;
  grid-template-rows: min-content 1fr;
`

const Header = styled.div``

const ToolbarGrid = styled.div`
  display: grid;
  width: 100%;
  align-items: center;
  > img,
  button {
    grid-row: 1 / -1;
  }

  img {
    width: 209px;
    justify-self: center;
    align-self: center;
  }

  .experience-manager-btn {
    justify-self: end;

    @media only screen and (max-width: 630px) {
      justify-self: center;
      grid-row: 3; 
     }
  }
`



// WEBPACK FOOTER //
// ./src/core/App.tsx